import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Mail } from "lucide-react";
import { useL } from "@/lib/useL";
import { api } from "@/lib/api";
import { SchoolOfferLink } from "@/components/SchoolOfferLink";

const CONTACT_EMAIL = "fiestaman38470@gmail.com";
const MAILTO = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(
  "[SUX1] Contact"
)}&body=${encodeURIComponent(
  "Bonjour,\n\nJe vous contacte au sujet de SUX1 :\n\n\n\n---\nEnvoyé depuis sux1.app"
)}`;

let cache = null;
const useSeller = () => {
  const [seller, setSeller] = useState(cache);
  useEffect(() => { if (!cache) api.get("/legal").then(({ data }) => { cache = data; setSeller(data); }).catch(() => {}); }, []);
  return seller;
};

// Legal identity line (mentions obligatoires), also shown under the login / sign-up pages.
export const LegalLine = ({ className = "" }) => {
  const seller = useSeller();
  if (!seller) return null;
  return (
    <p className={`text-[11px] text-muted-foreground leading-relaxed ${className}`} data-testid="footer-legal">
      {seller.name} · {seller.legal_id} · {seller.address.replace(/\n/g, ", ")} · {seller.vat_mention} · <Link to="/cgv" className="underline">CGV · Mentions légales</Link>
    </p>
  );
};

export const Footer = () => {
  const L = useL();
  return (
  <footer className="border-t border-border mt-16" data-testid="app-footer">
    <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
      <div className="flex items-center gap-3">
        <img src="/icons/sux1-192.png" alt="" aria-hidden="true" className="inline-block w-4 h-4" />
        <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-muted-foreground">
          SUX1 · © {new Date().getFullYear()}
        </span>
      </div>
      <nav className="flex flex-wrap items-center gap-x-6 gap-y-2 font-mono text-[11px] uppercase tracking-[0.2em]">
        <Link
          to="/about"
          data-testid="footer-about-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("À propos", "About")}
        </Link>
        <Link
          to="/etudiants"
          data-testid="footer-etudiants-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("Étudiants & chercheurs", "Students & researchers")}
        </Link>
        <Link to="/oeuvres" data-testid="footer-oeuvres-link" className="text-muted-foreground hover:text-foreground transition-colors">
          {L("Résumés d'œuvres", "Classic book summaries")}
        </Link>
        <Link to="/dys" data-testid="footer-dys-link" className="text-muted-foreground hover:text-foreground transition-colors">
          {L("Parents DYS", "DYS parents")}
        </Link>
        <Link
          to="/education"
          data-testid="footer-education-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("Établissements scolaires", "Schools")}
        </Link>
        <Link
          to="/enseignants"
          data-testid="footer-enseignants-link"
          className="text-[#002FA7] dark:text-blue-300 hover:text-[#002FA7] transition-colors"
        >
          {L("Livre pour enseignants", "Book for teachers")}
        </Link>
        <Link
          to="/privacy"
          data-testid="footer-privacy-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("Confidentialité", "Privacy")}
        </Link>
        <Link
          to="/cgv"
          data-testid="footer-cgv-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("CGV · Mentions légales", "Terms · Legal notice")}
        </Link>
        <Link
          to="/delete-account"
          data-testid="footer-delete-link"
          className="text-muted-foreground hover:text-foreground transition-colors"
        >
          {L("Supprimer compte", "Delete account")}
        </Link>
        <SchoolOfferLink variant="inline" testid="footer-school-offer-link" />
        <a
          href={MAILTO}
          data-testid="footer-contact-link"
          className="inline-flex items-center gap-1.5 text-[#002FA7] dark:text-blue-300 hover:text-[#002FA7] transition-colors"
        >
          <Mail className="w-3 h-3" /> Contact
        </a>
      </nav>
    </div>
    <LegalLine className="max-w-6xl mx-auto px-6 pb-6 -mt-2" />
  </footer>
  );
};

export default Footer;
